import { createRoot } from 'react-dom/client';
import IntegratorApp from './IntegratorApp';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from "history";
import { initI18nLocale } from './i18n';
import en from './locales/en/translation.json';

initI18nLocale({ en });
const history = createBrowserHistory();

const container = document.getElementById('_remote-dev-root');
const root = createRoot(container!);
root.render(
  <BrowserRouter>
    <IntegratorApp history={history} />
  </BrowserRouter>
);
